import i from "@emotion/styled/base";
import { greyColorObject as c } from "@partoohub/branding";
import "rc-slider/assets/index.css";
const t = /* @__PURE__ */ i("div", process.env.NODE_ENV === "production" ? {
  target: "e1qtwwg50"
} : {
  target: "e1qtwwg50",
  label: "SliderContainer"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvU2xpZGVyL1NsaWRlci5zdHlsZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3FFIiwiZmlsZSI6Ii9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvU2xpZGVyL1NsaWRlci5zdHlsZWQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZ3JleUNvbG9yT2JqZWN0IH0gZnJvbSAnQHBhcnRvb2h1Yi9icmFuZGluZyc7XG5pbXBvcnQgJ3JjLXNsaWRlci9hc3NldHMvaW5kZXguY3NzJztcblxuZXhwb3J0IGNvbnN0IFNsaWRlckNvbnRhaW5lciA9IHN0eWxlZC5kaXY8eyBjc3M/OiBTZXJpYWxpemVkU3R5bGVzIH0+YGA7XG5cbmV4cG9ydCBjb25zdCBkb3RTdHlsZSA9IHtcbiAgICBiYWNrZ3JvdW5kQ29sb3I6IGdyZXlDb2xvck9iamVjdC5pbml0aWFsLFxuICAgIGJvcmRlckNvbG9yOiBncmV5Q29sb3JPYmplY3QuaW5pdGlhbCxcbiAgICB3aWR0aDogJzhweCcsXG4gICAgaGVpZ2h0OiAnOHB4Jyxcbn07XG5cbmV4cG9ydCBjb25zdCBhY3RpdmVEb3RTdHlsZSA9IChjb2xvcjogc3RyaW5nKSA9PiAoe1xuICAgIGJhY2tncm91bmRDb2xvcjogY29sb3IsXG4gICAgYm9yZGVyQ29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgd2lkdGg6ICcxNnB4JyxcbiAgICBoZWlnaHQ6ICcxNnB4JyxcbiAgICBib3R0b206ICctNXB4Jyxcbn0pO1xuXG5leHBvcnQgY29uc3QgcmFpbFN0eWxlID0ge1xuICAgIGJhY2tncm91bmRDb2xvcjogZ3JleUNvbG9yT2JqZWN0LmluaXRpYWwsXG4gICAgaGVpZ2h0OiAnNHB4Jyxcbn07XG5leHBvcnQgY29uc3QgdHJhY2tTdHlsZSA9IChjb2xvcjogc3RyaW5nKSA9PiAoe1xuICAgIGJhY2tncm91bmRDb2xvcjogY29sb3IsXG4gICAgaGVpZ2h0OiAnNHB4Jyxcbn0pO1xuZXhwb3J0IGNvbnN0IGhhbmRsZVN0eWxlID0gKGNvbG9yOiBzdHJpbmcpID0+ICh7XG4gICAgYmFja2dyb3VuZENvbG9yOiBjb2xvcixcbiAgICBib3JkZXJDb2xvcjogJ3RyYW5zcGFyZW50JyxcbiAgICB3aWR0aDogJzE2cHgnLFxuICAgIGhlaWdodDogJzE2cHgnLFxuICAgIG1hcmdpblRvcDogJy03cHgnLFxufSk7XG4iXX0= */"), l = {
  backgroundColor: c.initial,
  borderColor: c.initial,
  width: "8px",
  height: "8px"
}, a = (b) => ({
  backgroundColor: b,
  borderColor: "transparent",
  width: "16px",
  height: "16px",
  bottom: "-5px"
}), I = {
  backgroundColor: c.initial,
  height: "4px"
}, d = (b) => ({
  backgroundColor: b,
  height: "4px"
}), e = (b) => ({
  backgroundColor: b,
  borderColor: "transparent",
  width: "16px",
  height: "16px",
  marginTop: "-7px"
});
export {
  t as SliderContainer,
  a as activeDotStyle,
  l as dotStyle,
  e as handleStyle,
  I as railStyle,
  d as trackStyle
};
